import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IUserResponse } from "../../Orchestrator/Types/Index";


export async function updateCustomerById(
    customerId: string,
    updateRequestBody: Record<string, any>
): Promise<IApiResponse<IUserResponse>> {
    const endpoints = await getEndpoints();
    const endpoint = `${endpoints.updateCustomerById}${customerId}`;

    return await apiRequest<IUserResponse>(endpoint, 'PUT', {
        body: JSON.stringify(updateRequestBody),
    });
}
